import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "../../../../shared/helper/UIHelpers";

const ModelUIContext = createContext();

export function useModelUIContext() {
  return useContext(ModelUIContext);
}

export function ModelUIProvider({ modelUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParams,
    newModelButtonClick: modelUIEvents.newModelButtonClick,
    openChangeStatusDialog: modelUIEvents.openChangeStatusDialog,
    openEditModelDialog: modelUIEvents.openEditModelDialog,
    openViewModelDialog: modelUIEvents.openViewModelDialog
  };

  return (
    <ModelUIContext.Provider value={value}>{children}</ModelUIContext.Provider>
  );
}
